
<div class="row row-cols-1 row-cols-md-2">
    <div class="col">
        <h4>VIVA MAIS - SEGUROS</h4>
    </div>
</div>

<div class="row row-cols-1 row-cols-md-2 mt-5">
    <div class="col">
      
        <div class="">
            <h5>Cuide da sua Segurança e de sua Família!</h5>
            <ul class="list-unstyled pl-3">
                <li>Seguro de Vida</li>
                <li>Seguro de Invalidez</li>
                <li>Seguro de Vida + Invalidez</li>
            </ul>
        </div>
        
        <div class="mt-5">
            <h5>A importância de ter o seguro Viva Mais Previdência:</h5>
            <p class="pl-3">
                Contrate cobertura adicional conforme suas
                necessidades e de sua família.
            </p>
        </div>
        
        <div class="mt-5">
            <h5>Personalize de acordo com suas necessidades!</h5>
            <p class="pl-3">
                Faça sua adesão 100% digital.
            </p>
        </div>

        <div class="mt-5">
            <a style="font-size: 14px;" target="_blank" href="https://arquivos.vivamaisprev.com.br/seguro/condicoes_gerais_icatu.pdf">Condições Gerais</a>
        </div>

    </div>
    <div class="col mt-5">
        <a class="btn btn-primary d-block m-auto" style="width: 300px;" target="_blank" href="https://arquivos.vivamaisprev.com.br/seguro/faq.pdf">TIRE SUAS DÚVIDAS</a>

        <br />

        <a class="btn btn-primary d-block mt-2 m-auto" style="width: 300px;" target="_blank" href="https://arquivos.vivamaisprev.com.br/seguro/material_explicativo.pdf">MATERIAL EXPLICATIVO</a>

    </div>
</div>    


<div class="d-flex justify-content-end mt-5">
    <button type="button" class="btn btn-success" (click)="proximo()">
        Próximo
        <i class="fas fa-chevron-right"></i>
    </button>
</div>